/**
 * Moment.js date and time patterns used by this application.
 *
 * They were the MOMENT_* constants of DateTimeFormats in the shared-components submodule, which dropped
 * moment for patterns in the Unicode/date-fns letters (`yyyy`, `dd`). Until this application moves off
 * moment too, its moment calls keep reading the moment patterns from here.
 */
export class MomentFormats {
  public static MOMENT_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
  public static MOMENT_DATETIME_FORMAT_NO_YEAR = "DD-MM HH:mm";
  public static MOMENT_DATETIME_FORMAT_NO_SECONDS = "YYYY-MM-DD HH:mm";
  public static MOMENT_DATETIME_FORMAT_SLASH = "YYYY/MM/DD HH:mm:ss";
  public static MOMENT_DATETIME_MIN = "2000-01-01 00:00:00";
  public static MOMENT_DATETIME_FORMAT_SHORT = "DD-MM-YYYY HH:mm:ss";
  public static MOMENT_DATETIME_FORMAT_SHORT_SLASH = "DD/MM/YYYY HH:mm:ss";
  public static MOMENT_DATETIME_FORMAT_SHORT_SLASH_NO_SECONDS = "DD/MM/YYYY HH:mm";
  public static MOMENT_DATETIME_FORMAT_SHORT_SLASH_NO_SECONDS_COMA = "DD/MM/YYYY, HH:mm";
  public static MOMENT_DATETIME_FORMAT_SHORT_NO_MIN_NO_SEC = "DD-MM-YYYY HH";
  public static MOMENT_DATETIME_FORMAT_SHORT_YEAR = "YYYY";
  public static MOMENT_DATETIME_FORMAT_SHORT_MONTH_YEAR = "MM YYYY";
  public static MOMENT_DATETIME_FORMAT_SHORT_WEEK = "W YYYY";
  public static MOMENT_DATETIME_FORMAT_SHORT_DAY = "dd DD-MM";
  public static MOMENT_DATETIME_FORMAT_SHORT_HOUR = "H";
  public static MOMENT_DATETIME_FORMAT_SHORT_DATE = " DD-MM";
  public static MOMENT_DATETIME_FORMAT_SHORT_DATE_SLASH = " DD/MM";
  public static MOMENT_DATETIME_FORMAT_SHORT_DATE_STRAIGHT = "DD-MM-YYYY";
  public static MOMENT_DATETIME_FORMAT_SHORT_DATE_INVERSE = "YYYY-MM-DD";
  public static MOMENT_DATETIME_FORMAT_LONG_HOUR_MINUTE_SECONDS = "HH:mm:ss";
  public static MOMENT_DATETIME_FORMAT_LONG_HOUR_MINUTE_SECONDS_MILLISECOND =
    "HH:mm:ss.SSS";

  public static MOMENT_DATETIME_FORMAT_LONG_HOUR_MINUTES = "HH:mm";
  public static MOMENT_DATETIME_FORMAT_LONG_MONTH_YEAR = "MMMM YYYY";
  public static MOMENT_DATETIME_FORMAT_DATE_YEAR = "DD/MM/YYYY";
  public static MOMENT_DATETIME_FORMAT_SHORT_DATE_YEAR = "DD/MM/YY";
  public static MOMENT_DATETIME_FORMAT_DATE_TIME_EXTEND =
    "DD MMMM YYYY HH:mm:ss";
  public static MOMENT_DATETIME_FORMAT_DEVICE_VALID_LIST =
    "YYYY-MM-DDTHH:mm:ss";
  public static MOMENT_DATETIME_DATE_EXTENDED = "DD MMMM YYYY";
  public static MOMENT_DATETIME_API_IT_CULTURE_INFO = "DD/MM/YYYY HH:mm:ss";
  public static MOMENT_DATETIME_FORMAT_ISO = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";
  public static MOMENT_DATETIME_FORMAT_ISO_UTC_SIMPLE = "YYYY-MM-DDTHH:mm:ssZ";
  public static MOMENT_DATETIME_FORMAT_ISO_UTC_WITH_TZD = "YYYY-MM-DDTHH:mm:ssTZD";
  public static MOMENT_DATETIME_FORMAT_DAY = "DD";
  public static MOMENT_DATETIME_FORMAT_LETTER_MONTH = "MMMM";
  public static MOMENT_DATETIME_FORMAT_YEAR_AND_MONTH = "YYYY-MM";
  /** It was AppSettings.DATETIME_ISO_8601_FORMAT, which kept its name but moved to the Unicode/date-fns letters */
  public static MOMENT_DATETIME_ISO_8601_FORMAT = "YYYY-MM-DDTHH:mmZ";
}
